module.exports = __webpack_public_path__ + "static/media/profile.fa0d6026.jpg";